import React from 'react';
import PropTypes from 'prop-types';

import FilterSet from 'components/Explorer/models/filter_set';
import ModalPicker from 'components/Explorer/AdvancedSearch/ModalPicker';
import createOutputCount from 'components/Explorer/AdvancedSearch/ModalPicker/outputCount';

const outputCount = createOutputCount('affiliations');

const AffiliationPickerFilter = ({ filterSet, initialSearch }) => (
  <ModalPicker
    filterSet={filterSet}
    initialSearch={initialSearch}
    i18nKey="affiliations"
    filterKey="affiliations[]"
    autocompletePath="/explorer/json_data/affiliations/search"
    childrenPath="/explorer/json_data/affiliations/children"
    bootstrapMethod="affiliations"
    analyticsDialogueName="Affiliation"
    maxSelected={null}
    helperText={[
      I18n.t('Explorer.AdvancedSearch.fields.affiliations.modal.helper_source'),
      I18n.t('Explorer.AdvancedSearch.fields.affiliations.modal.helper_coverage')
    ]}
    renderResultExtras={outputCount}
  />
);

AffiliationPickerFilter.propTypes = {
  filterSet: PropTypes.instanceOf(FilterSet).isRequired,
  initialSearch: PropTypes.string
};

export default AffiliationPickerFilter;
